/* Free gifts — the chooser on the product page
   ---------------------------------------------------------------------------
   Companion to gift-promo.js, which owns the promotions and every cart write.
   This file only draws a "choose" promotion's gifts and takes the shopper's
   pick. Automatic promotions need no chooser — gift-promo.js adds their gift by
   itself, and gift-promo-cta.js says so on the buy button.

   One chooser per mount. product-information.liquid renders
   <div data-gift-promo-chooser data-promotion="<id>"> for each choose promotion
   the product qualifies for; the gifts and the wording all come from that
   promotion in the list, so a new chooser promotion needs no change here.

   Replaces free-gift-chooser.js, which was a thin layer over Kite's own widget
   — restyling the app's rows and forwarding clicks to the app's claim button.
   The rows are ours now, and the state lives here rather than being read back
   out of the app's CSS classes.

   The pick survives add-to-cart. The shopper can choose before there is
   anything in the cart to earn it — gift-promo.js refuses to add a gift the
   cart has not qualified for — so the choice is held here and sent the moment
   the qualifying product lands. In memory only: a gift chosen on Tuesday
   should not still be pending on Friday.

   Copy never invents a price. A gift whose live price could not be fetched
   renders without one, for the reason set out in gift-promo.js's fetchLive. */

(function () {
  if (window.giftPromoChooserLoaded) return;
  window.giftPromoChooserLoaded = true;

  var MOUNT = "[data-gift-promo-chooser]";
  var BLOCK = "gp-chooser";
  var ROW = "gp-chooser__row";
  var PICKED = "gp-chooser__row--picked";

  var HEADER = "Choose Your Free Gift";
  var HINT_IDLE = "Select one to add to your order for free";
  var HINT_HELD = " — added when you add this to your cart";
  var HINT_IN_CART = " — added to your order for free";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function worth(gift) {
    if (gift.price == null || !window.GiftPromo) return "";
    return GiftPromo.money(gift.price);
  }

  function Chooser(host) {
    this.host = host;
    this.promoId = host.getAttribute("data-promotion");
    this.productId = host.getAttribute("data-product-id");
    this.heldPick = null;
    this.busy = false;
    this.state = null;
    this.gifts = [];
  }

  /* Which gift is in the cart, if any. Read off the line's variant rather than
     off our own pick, so a gift added from the cart drawer — or left over from a
     previous visit in a recovered cart — shows as chosen here too. */
  Chooser.prototype.inCartVariantId = function () {
    var s = this.state;
    return s && s.giftLine ? String(s.giftLine.variant_id) : null;
  };

  Chooser.prototype.rowHTML = function (gift, selectedId) {
    var value = worth(gift);
    var selected = selectedId && String(gift.variantId) === String(selectedId);
    return (
      '<li class="' + ROW + (selected ? " " + PICKED : "") + '"' +
      ' data-gift-variant="' + esc(gift.variantId) + '">' +
      '<button type="button" class="gp-chooser__hit"' +
      ' aria-pressed="' + (selected ? "true" : "false") + '">' +
      (gift.image
        ? '<img class="gp-chooser__img" src="' + esc(gift.image) + '" alt="" width="44" height="44" loading="lazy">'
        : '<span class="gp-chooser__img gp-chooser__img--empty"></span>') +
      '<span class="gp-chooser__name">' +
      esc(gift.label || gift.title) +
      (value ? '<small class="gp-chooser__worth">Worth ' + esc(value) + "</small>" : "") +
      "</span>" +
      '<span class="gp-chooser__radio" aria-hidden="true"></span>' +
      "</button></li>"
    );
  };

  Chooser.prototype.hintText = function () {
    var inCart = this.inCartVariantId();
    var selectedId = inCart || this.heldPick;
    if (!selectedId) return HINT_IDLE;

    var gift = this.gifts.filter(function (g) {
      return String(g.variantId) === String(selectedId);
    })[0];
    if (!gift) return HINT_IDLE;

    return (gift.label || gift.title) + (inCart ? HINT_IN_CART : HINT_HELD);
  };

  Chooser.prototype.paint = function () {
    /* A held pick rides along with Add to cart (see rideAlong in
       gift-promo.js): the mat goes in with the cockpit, in the same request,
       instead of being claimed once the cockpit has landed. Every change to
       the held pick is followed by a paint, so this keeps the two in step. */
    window.GiftPromo.rideAlong(this.promoId, this.heldPick, this.productId);
    if (!this.gifts.length) return;
    var selectedId = this.inCartVariantId() || this.heldPick;
    var self = this;

    this.host.innerHTML =
      '<div class="' + BLOCK + '">' +
      '<p class="gp-chooser__head">' + esc(HEADER) + "</p>" +
      '<ul class="gp-chooser__list">' +
      this.gifts.map(function (g) { return self.rowHTML(g, selectedId); }).join("") +
      "</ul>" +
      '<p class="gp-chooser__hint">' + esc(this.hintText()) + "</p>" +
      '<p class="gp-chooser__error" hidden></p>' +
      "</div>";

    this.host.hidden = false;
  };

  Chooser.prototype.setError = function (message) {
    var el = this.host.querySelector(".gp-chooser__error");
    if (!el) return;
    el.textContent = message || "";
    el.hidden = !message;
  };

  Chooser.prototype.setBusy = function (on) {
    this.busy = on;
    this.host.classList.toggle("gp-chooser--busy", !!on);
  };

  /* Sends a pick to the model. Anything already in the cart for this promotion
     comes out first: it gives one gift, and a second beside the first would be
     a gift the discount does not cover — which is to say, charged for. */
  Chooser.prototype.choose = function (variantId) {
    if (this.busy) return;
    var current = this.inCartVariantId();
    if (current && String(current) === String(variantId)) return;
    var self = this;
    var state = this.state;

    this.setError("");

    if (!state || !state.qualifies) {
      // Nothing to earn it yet. Hold the choice and say so.
      this.heldPick = String(variantId);
      this.paint();
      return;
    }

    this.setBusy(true);
    var swap = current
      ? fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: state.giftLine.key, quantity: 0 }),
        }).catch(function () {})
      : Promise.resolve();

    swap
      .then(function () { return window.GiftPromo.addGift(self.promoId, variantId); })
      .then(function (result) {
        self.setBusy(false);
        self.heldPick = null;
        if (!result.ok) self.setError(result.reason);
      })
      .catch(function () {
        self.setBusy(false);
        self.setError("We could not add that gift just now — nothing has been charged. Please try again.");
        window.GiftPromo.refresh();
      });
  };

  /* A held pick, sent as soon as the cart can carry it: the first
     announcement from gift-promo.js in which this promotion qualifies. */
  Chooser.prototype.sendHeldPick = function () {
    if (!this.heldPick || this.busy || !this.state || !this.state.qualifies) return false;
    if (this.inCartVariantId()) {
      // Something else already added the gift — the drawer, most likely.
      this.heldPick = null;
      return false;
    }
    var pick = this.heldPick;
    this.heldPick = null;
    this.choose(pick);
    return true;
  };

  Chooser.prototype.onChange = function (detail) {
    var self = this;
    this.state = (detail.promotions || []).filter(function (p) { return p.id === self.promoId; })[0] || null;
    if (this.sendHeldPick()) return;
    this.paint();
  };

  Chooser.prototype.start = function () {
    var self = this;
    // A promotion this shopper cannot have (switched off, or not in their
    // country) renders nothing, even if the mount is on the page.
    if (!window.GiftPromo.promotion(this.promoId)) return;

    this.host.addEventListener("click", function (event) {
      var row = event.target.closest("[data-gift-variant]");
      if (!row) return;
      event.preventDefault();
      self.choose(row.getAttribute("data-gift-variant"));
    });

    document.addEventListener("gift-promo:change", function (event) {
      self.onChange(event.detail);
    });

    window.GiftPromo.options(this.promoId).then(function (list) {
      self.gifts = list;
      if (!self.gifts.length) return;
      // The model announces on its own boot, but that may have happened
      // before the gift list arrived.
      if (self.state) self.paint();
      else window.GiftPromo.refresh();
    });
  };

  function start() {
    var hosts = document.querySelectorAll(MOUNT);
    Array.prototype.forEach.call(hosts, function (host) {
      if (host.giftPromoChooser) return;
      host.giftPromoChooser = new Chooser(host);
      host.giftPromoChooser.start();
    });
  }

  /* gift-promo.js defines window.GiftPromo, but the mounts are rendered by
     Liquid and the defer order is not something to rely on. */
  function watchForBoot() {
    if (document.querySelector(MOUNT) && window.GiftPromo) return start();
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (document.querySelector(MOUNT) && window.GiftPromo) {
        clearInterval(interval);
        start();
      } else if (tries > 40) {
        clearInterval(interval);
      }
    }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchForBoot);
  } else {
    watchForBoot();
  }
})();
